// extracted by mini-css-extract-plugin
module.exports = {"with-bg-color":"row-m__with-bg-color__1GTdu","with-no-bg-color":"row-m__with-no-bg-color__1WYwQ"};